import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  sublabel?: string;
  size?: "lg" | "md";
  className?: string;
};
export function CtaButton({
  label,
  id,
  sublabel,
  size = "lg",
  className = ""
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group relative mx-auto flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-gold-400 text-center font-display font-black uppercase text-navy-950 shadow-[0_8px_0_0_#c98f00,0_18px_30px_-10px_rgba(245,180,0,0.55)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-gold-300 active:translate-y-[4px] active:shadow-[0_4px_0_0_#c98f00] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/50 ${size === "lg" ? "px-5 py-5 text-[17px] leading-snug sm:px-8 sm:text-xl" : "px-4 py-3.5 text-base leading-tight"} ${className}`} data-id="element-27" data-mp="cj7rkk93nder">
      <span className="flex flex-col" data-id="element-28" data-mp="35xnycr12xwhs">
        <span className="text-balance" data-id="element-29" data-mp="35yqrl5lvkb0v">{label}</span>
        {sublabel && <span className="mt-1 font-sans text-xs font-semibold normal-case tracking-normal text-navy-900/75" data-id="element-30" data-mp="39zsr7njpep3d">
            {sublabel}
          </span>}
      </span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="3jwnmlxkok9df" />
    </a>;
}